import { Action } from '../../common/actions/core/action';

export class OpenPacketDeleteSuccessAction implements Action {
    constructor(
        public  messageSuccess?:String
    ){}
}



// WEBPACK FOOTER //
// src/app/packet/packet-delete-success-dialog/packet-delete-success-dialog.action.ts